import { api } from "@/lib/api";

function getSessionId() {
  let sid = localStorage.getItem("iwk_session");
  if (!sid) {
    sid = (window.crypto?.randomUUID && window.crypto.randomUUID()) ||
          `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("iwk_session", sid);
  }
  return sid;
}

export function trackVisit(path) {
  try {
    api.post("/track/visit", {
      session_id: getSessionId(),
      path: path || window.location.pathname,
      referrer: document.referrer || null,
    }).catch(() => {});
  } catch { /* ignore */ }
}

export function trackPlay(episode_number, voice) {
  try {
    const now = new Date();
    // JS getDay(): 0=Sun, 1=Mon, ..., 6=Sat — convert to Python Mon=0 ... Sun=6
    const jsDay = now.getDay();
    const pyWeekday = (jsDay + 6) % 7;
    api.post("/track/play", {
      session_id: getSessionId(),
      episode_number,
      voice: voice || null,
      local_hour: now.getHours(),
      local_weekday: pyWeekday,
      local_tz_offset_min: -now.getTimezoneOffset(),
    }).catch(() => {});
  } catch { /* ignore */ }
}
